import SectionHeading from "@/components/base/SectionHeading";
import { reviews } from "@/mocks/homeContent";

export default function Reviews() {
  return (
    <section id="reviews" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading kicker="Reviews" title={reviews.title} desc={reviews.desc} />

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {reviews.list.map((review) => (
            <figure
              key={review.name}
              className="flex h-full flex-col rounded-lg border border-background-200/70 bg-background-50 p-5"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 font-heading text-base font-semibold text-primary-700">
                  {review.name.slice(0, 1)}
                </span>
                <div className="flex-1">
                  <figcaption className="text-sm font-medium text-foreground-950">{review.name}</figcaption>
                  <p className="text-xs text-foreground-500">{review.meta}</p>
                </div>
              </div>

              <div className="mt-4 flex items-center gap-0.5 text-accent-500" aria-label={`评分 ${review.rating} 分，共 5 分`}>
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={i < review.rating ? "ri-star-fill text-sm" : "ri-star-line text-sm text-background-400"}
                  ></i>
                ))}
              </div>

              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                {review.text}
              </blockquote>

              <span className="mt-4 w-fit rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-medium text-secondary-900">
                #{review.tag}
              </span>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}